import { Component, OnInit } from '@angular/core';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { Match, Tornament } from '../Main.Model';

@Component({
    selector: 'app-database',
    templateUrl: './database.component.html',
    styleUrls: ['./database.component.css'],
    standalone: false
})
export class DatabaseComponent implements OnInit {

  Records: any[] = [];
  columns: any[];
  TotalFilteredResults: number = 0;
  UpdateMode: Boolean;
  
  Tables: String[] = ["Matches", "Players", "Torns", "Draws", "Entries", "Log", "ErrorLog"];
  TornFilter: number = 0;
  SelectedRecords: any[] = [];
  InfinitLoopProtector: Boolean = false;

  constructor(public DataService: DataService, private APIService: APIService) { }

  ngOnInit(): void {
    
  }

  resetColumns(records) {
    var obj = records[0];
    this.columns =  Object.keys(obj).filter(function(key) {
      if (obj.hasOwnProperty(key) && typeof key == 'string') {
        //key = key.replace('_',' ');
        return key;
      }
    });
  }

  TornFilterChanged() {
    if (this.InfinitLoopProtector == false) {
      this.tableChanged();
    } else {
      this.InfinitLoopProtector == false;
      setTimeout(() => {
        if (this.DataService.SelectedTable == "Matches") {
          this.Records = this.SelectedRecords.filter((match) => match.torn === this.TornFilter);
        }
      }, 500);
    }
  }

  tableChanged() {
    setTimeout(async () => {
      switch (this.DataService.SelectedTable) {
        case "Matches":
          this.SelectedRecords = this.DataService.Matches;
          this.InfinitLoopProtector = true;
          this.TornFilterChanged();
          this.resetColumns(this.SelectedRecords);
          break;
        case "Players":
          this.Records = this.DataService.Players;
          this.resetColumns(this.Records);
          break;
        case "Torns":
          this.Records = this.DataService.Torns;
          this.resetColumns(this.Records);
          break;
        case "Draws":
          if (this.TornFilter > 0) {
            let TheTorn = this.DataService.Torns.find((T) => T.id == this.TornFilter);
            TheTorn = await this.APIService.PopulateTornArrays(TheTorn);
            this.Records = TheTorn.draws;
            this.resetColumns(this.Records);  
          }
          break;
        case "Entries":
          if (this.TornFilter > 0) {
            let TheTorn = this.DataService.Torns.find((T) => T.id == this.TornFilter);
            TheTorn = await this.APIService.PopulateTornArrays(TheTorn);
            this.Records = TheTorn.entries;
            this.resetColumns(this.Records);  
          }
          break;
        case "Log":
          this.Records = await this.APIService.getLogs();
          this.Records.sort((a,b) => {return b.id - a.id})
          this.resetColumns(this.Records); 
          break;
        case "ErrorLog":
          this.Records = await this.APIService.getErrorLogs();
          this.Records.sort((a,b) => {return b.id - a.id})
          this.resetColumns(this.Records); 
          break;
      }
    }, 500);
  }
}
